
import { defineComponent } from 'vue';
import BackendFilters from '@/components/filters/Backend.vue';
import PublicFilters from '@/components/filters/Public.vue';
import DiaryKeyFigures from '@/views/Usage/DiaryKeyFigures.vue';
import FocusTable from '@/views/Usage/FocusTable.vue';
import HealthSegmentTable from '@/views/Usage/HealthSegmentTable.vue';
import ThoughtsTable from '@/views/Usage/ThoughtsTable.vue';
import MyBodyTable from '@/views/Usage/MyBodyTable.vue';

export default defineComponent({
    components: { BackendFilters, PublicFilters, FocusTable, DiaryKeyFigures, HealthSegmentTable, ThoughtsTable, MyBodyTable },
    data() {
        return {
            isPublic: false,
        };
    },
    created() {
        if (!window.location.href.includes('wp-admin')) {
            this.isPublic = true;
        }
    },
});
